import { Flex, Icon, Link, Text } from "@chakra-ui/react";
import { AttachmentIcon } from "@chakra-ui/icons";
import { RootState, useAppSelector } from "../../../store";
import { downloadFile } from "../../../helpers/DownloadFile";
import { ViewInformationBlock } from "@/components/ViewInformationBlock/ViewInformationBlock";
import { FiDatabase, FiDollarSign, FiFile, FiMapPin, FiMessageCircle, FiUser } from "react-icons/fi";
import dayjs from "dayjs";
import { UserRole } from "@/api/auth/types";
import { selectUserRole } from "@/store/slices/user";

export const SingleCandidateBlock = () => {
  const { currentCandidate } = useAppSelector((state: RootState) => state.candidates);

  const role = useAppSelector(selectUserRole);
  const isAdmin = role === UserRole.ADMIN;
  const isHRD = role === UserRole.HRD;

  if (!currentCandidate) return null;

  return (
    <Flex flexDirection="column" gap="24px">
      <ViewInformationBlock icon={<Icon as={FiUser as any} boxSize={5} color="#3b515e" />} title="Основная информация">
        <Flex flexDirection="column" gap="16px">
          <Flex justifyContent="space-between" gap="20px">
            <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
              <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
                ФИО
              </Text>
              <Text
                color="#3b515e"
                fontSize={16}
                lineHeight="24px"
                fontWeight={600}
              >{`${currentCandidate.last_name ?? ""} ${currentCandidate.first_name ?? ""} ${currentCandidate.patronymic_name ?? ""}`}</Text>
            </Flex>
            <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
              <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
                Источник
              </Text>
              <Text color="#3b515e" fontSize={16} lineHeight="24px" fontWeight={400}>{`${currentCandidate.source?.name || "—"}`}</Text>
            </Flex>
          </Flex>
          <Flex justifyContent="space-between" gap="20px">
            <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
              <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
                Должность
              </Text>
              <Text color="#3b515e" fontSize={16} lineHeight="24px" fontWeight={400}>{`${currentCandidate.expected_position || "—"}`}</Text>
            </Flex>
            <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
              <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
                Дата создания
              </Text>
              <Text color="#3b515e" fontSize={16} lineHeight="24px" fontWeight={400}>
                {currentCandidate.created_at ? `${dayjs.unix(Number(currentCandidate.created_at)).format("DD.MM.YYYY") || "—"}` : "—"}
              </Text>
            </Flex>
          </Flex>
          <Flex justifyContent="space-between" gap="20px">
            <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
              <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
                Грейд
              </Text>
              <Text
                w="max-content"
                color="#3b515e"
                fontSize={16}
                lineHeight="24px"
                fontWeight={500}
                padding={currentCandidate.grade?.name ? "2px 8px" : "0"}
                borderRadius="9999px"
                border={currentCandidate.grade?.name ? "1px solid #e1e7ef" : "none"}
              >{`${currentCandidate.grade?.name || "—"}`}</Text>
            </Flex>
            <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
              <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
                Статус кандидата
              </Text>
              <Text
                w="max-content"
                color="#3b515e"
                fontSize={16}
                lineHeight="24px"
                fontWeight={400}
                padding="2px 8px"
                borderRadius="9999px"
                border="1px solid #e1e7ef"
              >{`${currentCandidate.status?.name || "—"}`}</Text>
            </Flex>
          </Flex>
          <Flex justifyContent="space-between" gap="20px">
            <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
              <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
                Дата рождения
              </Text>
              <Text color="#3b515e" fontSize={16} lineHeight="24px" fontWeight={400}>
                {currentCandidate.birthday ? `${dayjs(currentCandidate.birthday).format("DD.MM.YYYY") || "—"}` : "—"}
              </Text>
            </Flex>
            <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
              <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
                Ссылка
              </Text>
              {currentCandidate.url && (
                <Link
                  href={currentCandidate.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  color="#2563eb"
                  fontSize={16}
                  lineHeight="24px"
                  fontWeight={400}
                >{`${currentCandidate.url || "—"}`}</Link>
              )}
              {!currentCandidate.url && (
                <Text color="#3b515e" fontSize={16} lineHeight="24px" fontWeight={400}>
                  —
                </Text>
              )}
            </Flex>
          </Flex>
          <Flex justifyContent="space-between" gap="20px">
            <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
              <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
                Комментарии
              </Text>
              <Text color="#3b515e" fontSize={16} lineHeight="24px" fontWeight={400}>{`${currentCandidate.comments || "—"}`}</Text>
            </Flex>
          </Flex>
          {(isAdmin || isHRD) && (
            <Flex justifyContent="space-between" gap="20px">
              {isAdmin && (
                <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
                  <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
                    Канал подбора
                  </Text>
                  <Text color="#3b515e" fontSize={16} lineHeight="24px" fontWeight={400}>{`${currentCandidate.channel?.name || "—"}`}</Text>
                </Flex>
              )}
            </Flex>
          )}
        </Flex>
      </ViewInformationBlock>
      <ViewInformationBlock icon={<Icon as={FiDollarSign as any} boxSize={5} color="#3b515e" />} title="Финансовая информация">
        <Flex justifyContent="space-between">
          <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
            <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
              Зарплата, на руки
            </Text>
            <Text
              color="#3b515e"
              fontSize={16}
              lineHeight="24px"
              fontWeight={500}
            >{`${currentCandidate.expected_salary?.sum || "—"} ${currentCandidate.expected_salary?.currency.name || ""}`}</Text>
          </Flex>
          <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
            <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
              Внутренняя ставка кандидата
            </Text>
            <Text color="#3b515e" fontSize={16} lineHeight="24px" fontWeight={500}>{`${currentCandidate.internal_rate || "—"}`}</Text>
          </Flex>
        </Flex>
      </ViewInformationBlock>
      <ViewInformationBlock icon={<Icon as={FiMapPin as any} boxSize={5} color="#3b515e" />} title="Местоположение">
        <Flex justifyContent="space-between">
          <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
            <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
              Страна проживания
            </Text>
            <Text color="#3b515e" fontSize={16} lineHeight="24px" fontWeight={400}>{`${currentCandidate.country?.name || "—"}`}</Text>
          </Flex>
          <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
            <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
              Город проживания
            </Text>
            <Text color="#3b515e" fontSize={16} lineHeight="24px" fontWeight={400}>{`${currentCandidate.town || "—"}`}</Text>
          </Flex>
        </Flex>
      </ViewInformationBlock>
      <ViewInformationBlock icon={<Icon as={FiMessageCircle as any} boxSize={5} color="#3b515e" />} title="Контактная информация">
        <Flex flexDirection="column" gap="16px">
          <Flex justifyContent="space-between" gap="20px">
            <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
              <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
                Email
              </Text>
              <Text color="#3b515e" fontSize={16} lineHeight="24px" fontWeight={400}>{`${currentCandidate.contact_email || "—"}`}</Text>
            </Flex>
            <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
              <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
                Телефон
              </Text>
              <Text color="#3b515e" fontSize={16} lineHeight="24px" fontWeight={400}>{`${currentCandidate.contact_phone || "—"}`}</Text>
            </Flex>
          </Flex>
          <Flex justifyContent="space-between" gap="20px">
            <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
              <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
                Telegram
              </Text>
              <Text color="#3b515e" fontSize={16} lineHeight="24px" fontWeight={400}>{`${currentCandidate.contact_telegram || "—"}`}</Text>
            </Flex>
            <Flex flexDirection="column" gap="8px" height="max-content" w="50%">
              <Text color="#65758b" fontSize={14} lineHeight="20px" fontWeight={500}>
                Доп. контакты
              </Text>
              <Text color="#3b515e" fontSize={16} lineHeight="24px" fontWeight={400}>{`${currentCandidate.contacts || "—"}`}</Text>
            </Flex>
          </Flex>
        </Flex>
      </ViewInformationBlock>
      <ViewInformationBlock icon={<Icon as={FiDatabase as any} boxSize={5} color="#3b515e" />} title="Ключевые навыки">
        <Flex gap="4px" flexWrap="wrap">
          {currentCandidate.skills?.map((skill) => (
            <Text
              key={skill.id}
              color="#3b515e"
              fontSize={14}
              lineHeight="20px"
              fontWeight={600}
              padding="2px 8px"
              borderRadius="9999px"
              border="1px solid #e1e7ef"
            >
              {skill.name}
            </Text>
          ))}
        </Flex>
      </ViewInformationBlock>
      <ViewInformationBlock icon={<Icon as={FiFile as any} boxSize={5} color="#3b515e" />} title="Вложения">
        <Flex gap="4px" flexWrap="wrap">
          {currentCandidate?.attachments &&
            Object.entries(currentCandidate.attachments).map(([_key, el]) => {
              return (
                <Flex
                  w="100%"
                  key={el.id}
                  display="flex"
                  alignItems="center"
                  gap="6px"
                  bgColor="#f1f5f9"
                  p="4px 8px"
                  borderRadius="4px"
                  sx={{
                    "&:hover": {
                      cursor: "pointer",
                      opacity: 0.6,
                    },
                  }}
                  onClick={() => downloadFile(el.id, el.name)}
                >
                  <AttachmentIcon style={{ verticalAlign: "text-top" }} />
                  <Text display="inline">{el.name}</Text>
                </Flex>
              );
            })}
        </Flex>
      </ViewInformationBlock>
    </Flex>
  );
};
